import { lookupLocal, fillTemplate } from '../../lib/brandText';

// ─────────────────────────────────────────────────────────────────────────────
// The names of the credit ledger's own lines — a sign-up gift, a top-up, a
// store purchase, a gift code, a prize — by their reason code (Credits.shared.js
// `transactionLabels`). They belong in the kit's credits.json and move there with
// the next kit release (the kit-lag rule, as in src/lib/receptionStrings.js):
// until then they live here, and a caller asks the kit FIRST, so the day a
// released catalogue has a key the kit's wording wins and this entry is dead.
// Persian is authoritative; en and ar carry every key (parity is tested).
// `{{coin}}` is the brand's credit, resolved per language (src/lib/brandText.js).
// ─────────────────────────────────────────────────────────────────────────────

import fa from './strings/fa.json';
import en from './strings/en.json';
import ar from './strings/ar.json';

const flatten = (obj, prefix = '', out = {}) => {
  for (const [k, v] of Object.entries(obj)) {
    const key = prefix ? `${prefix}.${k}` : k;
    if (v && typeof v === 'object' && !Array.isArray(v)) flatten(v, key, out); else out[key] = v;
  }
  return out;
};

const STRINGS = { fa: flatten(fa), en: flatten(en), ar: flatten(ar) };

/** Whether this module owns a key (so a caller can fall back to it). */
export const hasLocalLedgerString = (key) => Object.prototype.hasOwnProperty.call(STRINGS.fa, key);

/** Look a key up in the local table (Persian as the fallback) — exported for tests. */
export function localLedgerString(locale, key, vars) {
  const { value, from } = lookupLocal(STRINGS, locale, key);
  return value == null ? key : fillTemplate(value, vars, from);
}

export const LEDGER_STRING_LOCALES = Object.keys(STRINGS);
export const LEDGER_STRING_KEYS = Object.keys(STRINGS.fa);
export const ledgerStringTable = (locale) => STRINGS[locale];
